import { PaymentOwnContract } from './PaymentOwnContract.js';
import { PaymentDirectDebit } from './PaymentDirectDebit.js';
import { PaymentPaypal } from './PaymentPaypal.js';
import { PaymentCreditCard } from './PaymentCreditCard.js';

let PaymentMethod = /*#__PURE__*/function (PaymentMethod) {
  PaymentMethod["CREDITCARD"] = "CREDITCARD";
  PaymentMethod["CREDITCARD3DSECURE"] = "CREDITCARD3DSECURE";
  PaymentMethod["DIRECTDEBIT"] = "DIRECTDEBIT";
  PaymentMethod["FREE"] = "FREE";
  PaymentMethod["OWNCONTRACT"] = "OWNCONTRACT";
  PaymentMethod["PAYPAL"] = "PAYPAL";
  PaymentMethod["BANCONTACT"] = "BANCONTACT";
  return PaymentMethod;
}({});
const getPaymentMethodModel = (paymentMethod, data) => {
  switch (paymentMethod) {
    case PaymentMethod.CREDITCARD:
    case PaymentMethod.CREDITCARD3DSECURE:
      return PaymentCreditCard.createFromResponse(data);
    case PaymentMethod.PAYPAL:
      return PaymentPaypal.createFromResponse(data);
    case PaymentMethod.DIRECTDEBIT:
    case PaymentMethod.FREE:
      return PaymentDirectDebit.createFromResponse(data);
    case PaymentMethod.OWNCONTRACT:
      return PaymentOwnContract.createFromResponse(data);
    default:
      return undefined;
  }
};
const deserializePaymentMethod = (paymentMethod, data) => {
  switch (paymentMethod) {
    case PaymentMethod.CREDITCARD:
    case PaymentMethod.CREDITCARD3DSECURE:
      return PaymentCreditCard.deserialize(data);
    case PaymentMethod.PAYPAL:
      return PaymentPaypal.deserialize(data);
    case PaymentMethod.DIRECTDEBIT:
    case PaymentMethod.FREE:
      return PaymentDirectDebit.deserialize(data);
    case PaymentMethod.OWNCONTRACT:
      return PaymentOwnContract.deserialize(data);
    default:
      return undefined;
  }
};
const getPaymentMethods = paymentMethods => paymentMethods.map(p => getPaymentMethodModel(PaymentMethod[p.payment_method], p)).filter(paymentMethod => !!paymentMethod);

export { PaymentMethod, deserializePaymentMethod, getPaymentMethodModel, getPaymentMethods };
//# sourceMappingURL=PaymentMethod.js.map
